export const handleActivityCodeHelper = (selectedOption) => {
  let ac = [];
  selectedOption.map((item) => {
    ac.push(item.value);
  });
  let updateDataQuery = {
    activitycodes: ac.length > 0 ? ac.join(",") : "all",
  };
  return updateDataQuery;
};
